<div id="container">
    <div class="slideBox">
        <mat-slide-toggle color="primary" (change)="changeColumsStructure($event)">{{'PLANNER.visualizzazione_commesse'
            | translate}}</mat-slide-toggle>
    </div>

    <bryntum-scheduler-pro-project-model #project [resources]="resources" [events]="events" [assignments]="assignments"
        [timeRangeStore]="myTimeRangeStore" [timeRanges]="timeRanges"></bryntum-scheduler-pro-project-model>


    <bryntum-scheduler-pro #schedulerpro [columns]="columns" [cls]="cls" [project]="project"
        [barMargin]="schedulerProConfig.barMargin" [eventStyle]="schedulerProConfig.eventStyle"
        [viewPreset]="schedulerProConfig.viewPreset" [infiniteScroll]="schedulerProConfig.infiniteScroll"
        [eventLayout]="eventLayout" [features]="features" [tbar]="tbarConfig" [createEventOnDblClick]="false"
        [listeners]="listeners" [eventRenderer]="" [eventEditFeature]="getEventEdit()"
        (onBeforeEventSave)="saveEvent($event)"></bryntum-scheduler-pro>
</div>



<ng-template #reopenConfirm let-data>
  <h2 mat-dialog-title>{{ data?.title || 'Operazione non riuscita' }}</h2>

  <mat-dialog-content>
    <p>
      {{ data?.message || 'La richiesta è andata in errore. Vuoi riaprire la modale con i dati precedenti per correggerli?' }}
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">
      {{ data?.cancelLabel || 'No' }}
    </button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true">
      {{ data?.okLabel || 'Sì, riapri' }}
    </button>
  </mat-dialog-actions>
</ng-template>
